import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { Storefront as StorefrontIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import StatusChip from '../common/StatusChip';

const OrderHeader = ({ order, client, orderType, onCancel, cancelLabel = 'Cancelar' }) => {
    const navigate = useNavigate();
    const { user } = useAuth();

    if (!order) return null;

    return (
        <Box sx={{ bgcolor: 'white', borderBottom: '1px solid #e7edf3', px: 3, py: 1.5, pt: { xs: 7, md: 1.5 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0e141b', fontSize: { xs: '1.125rem', md: '1.25rem' }, whiteSpace: 'nowrap' }}>
                            {order.status === 'borrador' ? 'Nuevo Pedido' : 'Editar Pedido'} {order.order_number}
                        </Typography>
                        <StatusChip status={order.status} sx={{ fontSize: '0.75rem', height: 20 }} />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        {client ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Typography sx={{ color: '#4e7397', fontSize: '0.875rem', fontWeight: 500 }}>
                                    Cliente:
                                </Typography>
                                <Typography sx={{ color: '#0e141b', fontSize: '0.875rem', fontWeight: 600 }}>
                                    {client.name}
                                </Typography>
                                <Typography sx={{ color: '#4e7397', fontSize: '0.875rem' }}>
                                    - {client.delivery_address}
                                </Typography>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<StorefrontIcon />}
                                    onClick={() => navigate(`/orders/${orderType || 'public'}/select-client`)}
                                    sx={{
                                        ml: 1, fontSize: '0.75rem', height: 28, px: 1.5,
                                        borderColor: '#1976d2', color: '#1976d2', textTransform: 'none',
                                        '&:hover': { borderColor: '#1565c0', bgcolor: '#e3f2fd' },
                                    }}
                                >
                                    Cambiar
                                </Button>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Typography sx={{ color: '#f57c00', fontSize: '0.875rem', fontWeight: 600 }}>
                                    {user?.is_wholesale_client 
                                        ? `Cliente: ${user.first_name || user.username}`
                                        : 'Cliente: Sin asignar'
                                    }
                                </Typography>
                                {!user?.is_wholesale_client && (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        startIcon={<StorefrontIcon />}
                                        onClick={() => navigate(`/orders/${orderType || 'public'}/select-client`)}
                                        sx={{
                                            ml: 1, fontSize: '0.8125rem', height: 32, px: 2,
                                            bgcolor: '#ff9800', color: 'white', fontWeight: 600, textTransform: 'none',
                                            boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { bgcolor: '#f57c00', boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)' },
                                        }}
                                    >
                                        Seleccionar Cliente
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={onCancel}
                        sx={{
                            borderColor: '#e7edf3', color: '#0e141b', height: 32, px: 2,
                            fontSize: '0.875rem', fontWeight: 500, textTransform: 'none',
                            '&:hover': { borderColor: '#e7edf3', bgcolor: '#f5f5f5' },
                        }}
                    >
                        {cancelLabel}
                    </Button>
                </Box>
            </Box>

            {(!client && !user?.is_wholesale_client) && (
                <Alert severity="warning" icon={<StorefrontIcon />} sx={{ mt: 1.5, py: 0 }}>
                    Por favor seleccione un cliente para continuar con el pedido.
                </Alert>
            )}
        </Box>
    );
};

export default OrderHeader;
